import { MarketoForm, useAuth, useContact, usePageModels } from '@/context';
import React from 'react';
import { useCookies } from 'react-cookie';
import { useMarketo } from '../Marketo';
import { useOneTrustReady } from './useOneTrustReady';

export const MARKETO_SESSION_LINK_COOKIE = 'marketoSessionLink';

export const useMarketoSessionLink = () => {
  const { isAuthorized, isAuthorizing } = useAuth();
  const { contactInfo } = useContact();
  const { marketo, isLoading, loadForm } = useMarketo();
  const {
    config: {
      marketo: {
        portal_activity_tracking_form_id: portalActivityTrackingFormId = '',
        email_fieldname: emailFieldName = '',
      } = {},
    },
  } = usePageModels();
  const { ready: oneTrustReady } = useOneTrustReady();
  const [
    { [MARKETO_SESSION_LINK_COOKIE]: marketoSessionLink, _mkto_trk: marketoTracking },
    setCookie,
    // removeCookie,
  ] = useCookies();
  const sessionLinked = React.useMemo(
    () => marketoSessionLink === marketoTracking,
    [marketoSessionLink, marketoTracking],
  );

  const submit = React.useCallback(
    (form?: MarketoForm) => {
      console.log('submit', { form });
      if (!form) return;

      form.addHiddenFields({
        [emailFieldName]: contactInfo?.emailaddress1,
      });

      form.submit();
    },
    [contactInfo, emailFieldName],
  );

  const handleSuccess = React.useCallback(() => {
    setCookie(MARKETO_SESSION_LINK_COOKIE, marketoTracking);
  }, [marketoTracking, setCookie]);

  React.useEffect(() => {
    console.log('useMarketoSessionLink', {
      sessionLinked,
      oneTrustReady,
      isLoading,
      isAuthorizing,
      isAuthorized,
      contactInfo,
      marketo,
      portalActivityTrackingFormId,
    });
    if (sessionLinked) return;
    if (!oneTrustReady) return;
    if (isLoading) return;
    if (isAuthorizing || !isAuthorized) return;
    if (!contactInfo) return;
    if (!marketo) return;
    if (!portalActivityTrackingFormId) return;

    loadForm({
      formId: portalActivityTrackingFormId,
      onSuccess: handleSuccess,
    }).then(submit);
  }, [
    sessionLinked,
    oneTrustReady,
    isLoading,
    isAuthorizing,
    isAuthorized,
    contactInfo,
    marketo,
    portalActivityTrackingFormId,
    submit,
    loadForm,
    handleSuccess,
  ]);
};
